<template lang="pug">
    .hzDrop(ref="container", tabindex="-1", @blur.capture="_blurHandler($event)")
        .dropHead(ref="dropHead", tabindex="-1", @focus.capture="show($event)", @mouseenter.capture="showHover($event)", @mouseout.capture="hideHover")
            slot(name="dropHead")
        .hzDropBody(ref="dropBody", tabindex="-1", @blur.capture="_blurHandler($event)", :style="dropBodyStyle", v-if="isShow", @mouseenter.capture="showHover($event)", @mouseout.capture="hideHover")
            slot(name="dropBody")
</template>

<script>    
    export default {
        name: 'hz-dropdown',
        props: {
            isHover: { type: Boolean, default: false },
            dropBodyStyle: null,
            isSetMinWidth: { type: Boolean, default: true},
            disabled: { type: Boolean, default: false }
        },
        data() {
            return {
                popperElm: null,
                isShow: false,
                scrollTimer: null
            }
        },

        computed: {
            dropBody() {
                return this.$refs.dropBody;
            }
        },

        beforeDestroy() {
            this.$refs.dropBody && $(this.$refs.dropBody).remove();
        },

        methods: {
            //检测当前active的元素是否位于节点中
            _isInPopperElm(context, target) {
                let popperElms = [];
                let getChildPopperElm = function(ctx) {
                    if(ctx.popperElm) {
                        popperElms.push(ctx.popperElm);
                    }
                    ctx.$children && ctx.$children.length && ctx.$children.map(one => {
                        getChildPopperElm(one);
                    })
                }
                getChildPopperElm(context);
                let index = popperElms.findIndex(one => {
                    return one.contains(target) || one.contains(target);
                })

                return index !== -1;
            },

            _blurHandler(event) {
                let el = this.$refs.container;
                //blur先与下一个focus触发，所以setTimeout下，让focus到body
                setTimeout(e => {
                    let activeEle = document.activeElement;
                    // console.log('_blurHandler:', el, activeEle, this.$refs.container);
                    if (el === activeEle || el.contains(activeEle) || this._isInPopperElm(this, activeEle)) {
                        return;
                    }
                    this.hide();
                }, 0)
            },

            hideHover() {
                // console.log('hidehover');
                clearTimeout(this._timer);
                if(this.isHover) {
                    this._timer = setTimeout(e => {
                        this.hide();
                    }, 60)
                }
            },

            hide () {  
                if(this.isShow) {
                    this.$emit('hide');
                    this.isShow = false;
                    //如果是popperElm子元素，则focus住
                    this.$refs.container && $(this.$refs.container).parents('.hzDropBody').length > 0 && this.$refs.container.focus();
                }   
            },

            showHover(event) {
                // console.log('showhover');
                clearTimeout(this._timer);
                this.isHover && this.show(event);
            },

            show (event) {
                if(event.target && event.target.nodeName === 'I' || this.isShow || this.disabled) {
                    return;
                }

                this.$refs.dropBody && (this.$refs.dropBody.style.minWidth = '0px');
                this.$emit('beforeShow');

                this.$nextTick(e => {
                    this.isShow = true;
                    this.$nextTick(e => {
                        this.popperElm = this.$refs.dropBody;
                        this.$refs.container.popperElm = this.popperElm;
                        let dropBody = $(this.$refs.dropBody);

                        this.$refs.dropBody.style.left = 0;
                        this.$refs.dropBody.style.top = 0;
                        this.$refs.dropBody.style.opacity = 0;
                       
                        dropBody.appendTo(document.body);


                        let isTop = this.setPosition() === 1;

                        this.$nextTick(e => {
                            this.$emit('show', isTop);
                        })

                        dropBody.on('scroll', e => {
                            clearTimeout(this.scrollTimer);
                            this.scrollTimer = setTimeout(e => {
                                this.$emit('scroll', dropBody.height(), dropBody.scrollTop(), dropBody);
                            }, 30)
                        });
                    })
                })
            },

            _put(top, maxHeight, isTop) {
                this.$refs.dropBody.style.top = top + 'px';
                this.$refs.dropBody.style.opacity = 1;
                this.$refs.dropBody.style.maxHeight = maxHeight + 'px';
                if(isTop) {
                    this.$refs.dropBody.classList.remove('zFadeIn');
                    this.$refs.dropBody.style.transform = 'translate(0, -100%)';
                }
                else {
                    this.$refs.dropBody.classList.add('zFadeIn');
                    this.$refs.dropBody.style.transform = 'none';
                }
            },

            //放到上面返回1，放到下面返回-1
            setPosition() {
                let dropBody = this.$refs.dropBody;
                let bodyWidth = dropBody.clientWidth;
                let headWidth = this.$refs.dropHead.clientWidth;
                bodyWidth = bodyWidth > headWidth? bodyWidth : headWidth;
                this.isSetMinWidth && (dropBody.style.minWidth = bodyWidth + 'px');

                let scrollTop, scrollLeft;
                if(document.documentElement && document.documentElement.scrollTop){  
                    scrollTop = document.documentElement.scrollTop;  
                }else if(document.body){  
                    scrollTop = document.body.scrollTop;  
                }

                if(document.documentElement && document.documentElement.scrollLeft){  
                    scrollLeft = document.documentElement.scrollLeft;  
                }else if(document.body){  
                    scrollLeft = document.body.scrollLeft;  
                }  


                let docRight = document.documentElement.clientWidth + scrollLeft;
                let headLeft = $(this.$refs.dropHead).offset().left;

                let left = headLeft + bodyWidth > docRight? headLeft + headWidth - bodyWidth - scrollLeft : headLeft - scrollLeft;

                dropBody.style.left =  left + 'px';
                
                let docHeight = document.documentElement.clientHeight;
                let docTop = scrollTop;
                let docBottom = docHeight + scrollTop;
                let headTop = $(this.$refs.dropHead).offset().top;
                let headHeight = $(this.$refs.dropHead).outerHeight();
                let headBottom = headTop + headHeight;

                var bodyHeight = dropBody.clientHeight;

                let bottomSpace = docBottom - headBottom - 10;
                let topSpace = headTop - docTop - 50;
                
                 // 可以放到下面
                if(bottomSpace > bodyHeight) {
                    this._put(headBottom, bottomSpace);
                    return -1;
                }
                
                //上面可以容纳
                if(topSpace > bodyHeight) {
                    this._put(headTop, topSpace, true);
                    return 1;
                }

                let maxHeight = (topSpace > bottomSpace? topSpace : bottomSpace) + 'px';
                // console.log('都容纳不了', [topSpace, bottomSpace, maxHeight, bodyHeight]);
                $(dropBody).css({'max-height': maxHeight});
                let isTop = topSpace > bottomSpace;
                this._put(isTop? headTop : headBottom, maxHeight, isTop);

                return isTop? 1: -1;
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .hzDrop
        position relative
        display inline-block
        &:focus
            outline none
    .dropHead
        &:focus
            outline none
        .dropdown-icon
            font-size 14px
            margin-left 5px
            transition transform .4s
            color #fff
            &.active
                transform rotate(180deg)
    .hzDropBody
        width auto
        overflow auto
        position fixed
        z-index 1001
        background #fff
        border-radius 4px
        border 1px solid #e4e7ed
        list-style none
        overflow auto
        box-shadow 0 2px 12px 0 rgba(0,0,0,.1)
        line-height 25px
        &:focus
            outline none
    
    @keyframes fadeInDown 
        0% 
            opacity 0
            transform scaleY(0.6)
        100% 
            opacity 1
            transform none
    .zFadeIn
        transform-origin center top
        animation fadeInDown .2s
</style>




// WEBPACK FOOTER //
// src/dropdown.vue